import styled, { css } from 'styled-components';

export const TableHead = styled.thead`
  tr {
    th {
      height: 35px;
      font-size: 15px;
      opacity: 1;
      font-weight: 900;

      &:hover {
        opacity: 0.6;
      }
    }
  }
  &.sticky {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 20;
    border-bottom: 1px solid #aaa;
    box-shadow: 0 1px 15px rgba(0, 0, 0, 0.3);
    background: #fff;
    th {
      height: 50px;
    }
    ${(props) =>
      props.theme.theme === 'dark' &&
      css`
        border-bottom: 1px solid #464b51;
        box-shadow: 0 1px 15px rgba(255, 255, 255, 0.1);
        background: #262b31;
      `};
  }
`;

export const TableRow = styled.tr``;
